(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORE_KEY = 'byrnaShipCalc';
  var FALLBACK_PROVINCES = ['Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Ciudad Autónoma de Buenos Aires', 'Corrientes', 'Córdoba', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago Del Estero', 'Tierra Del Fuego', 'Tucumán'];
  function load() { try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {} }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, map) {
    return esc(tpl).replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function money(amount) {
    var n = parseFloat(amount) || 0;
    try {
      return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return '$ ' + n; }
  }
  function normalizeZip(raw) {
    var z = String(raw || '').toUpperCase().replace(/[\s-]+/g, '');
    var m = z.match(/^[A-Z]?(\d{4})[A-Z]{0,3}$/);
    return m ? m[1] : null;
  }
  function provinces(widget) {
    var sel = widget.querySelector('[data-ship-calc-countries]');
    if (sel) {
      var opt = Array.prototype.find.call(sel.options, function (o) { return o.value === 'Argentina'; });
      if (opt && opt.getAttribute('data-provinces')) {
        try {
          var list = JSON.parse(opt.getAttribute('data-provinces'));
          if (list && list.length) return list.map(function (p) { return [p[0], p[1] || p[0]]; });
        } catch (e) {}
      }
    }
    return FALLBACK_PROVINCES.map(function (n) { return [n, n]; });
  }
  function query(addr) {
    return 'shipping_address%5Bzip%5D=' + encodeURIComponent(addr.zip) +
      '&shipping_address%5Bcountry%5D=Argentina' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(addr.province);
  }
  function failOn(r) {
    return r.json().then(function (e) { throw e || {}; }, function () { throw {}; });
  }
  function poll(q, n) {
    return fetch(root + 'cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : failOn(r); })
      .then(function (data) {
        if (data && data.shipping_rates) return data.shipping_rates;
        if (n >= 20) throw { timeout: true };
        return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return poll(q, n + 1); });
      });
  }
  function fetchRates(addr) {
    var q = query(addr);
    return fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? poll(q, 0) : failOn(r); });
  }
  function setResult(widget, html, state) {
    var box = widget.querySelector('[data-ship-calc-result]');
    box.className = 'ship-calc__result' + (state ? ' is-' + state : '');
    box.innerHTML = html;
  }
  function showRates(widget, rates, zip) {
    var d = widget.dataset;
    if (!rates || !rates.length) { setResult(widget, esc(d.textNone), 'error'); return; }
    rates = rates.slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    if (d.cheapestOnly === 'true') rates = [rates[0]];
    var html = rates.map(function (r) {
      var price = parseFloat(r.price) || 0;
      var name = esc(r.presentment_name || r.name || '');
      if (price === 0) {
        return '<div class="ship-calc__rate is-free"><span>' + fill(d.textFree, { cp: esc(zip), metodo: name, precio: money(0) }) + '</span></div>';
      }
      return '<div class="ship-calc__rate"><span>' + fill(d.textRate, { cp: esc(zip), metodo: name, precio: '<strong>' + money(price) + '</strong>' }) + '</span></div>';
    }).join('');
    setResult(widget, html, '');
  }
  function run(widget) {
    var d = widget.dataset;
    var provSel = widget.querySelector('[data-ship-calc-province]');
    var zipInput = widget.querySelector('[data-ship-calc-zip]');
    var btn = widget.querySelector('[data-ship-calc-submit]');
    var zip = normalizeZip(zipInput.value);
    if (!provSel.value || !zip) { setResult(widget, esc(d.textInvalid), 'error'); return; }
    var token = String(Date.now() + Math.random());
    widget.dataset.scToken = token;
    btn.disabled = true;
    setResult(widget, 'Calculando…', 'loading');
    save({ zip: zipInput.value.trim(), province: provSel.value, ran: true });
    fetchRates({ zip: zip, province: provSel.value })
      .then(function (rates) { if (widget.dataset.scToken === token) showRates(widget, rates, zip); })
      .catch(function () { if (widget.dataset.scToken === token) setResult(widget, esc(d.textError), 'error'); })
      .then(function () { btn.disabled = false; });
  }
  function init(widget) {
    if (widget.dataset.scReady) return;
    widget.dataset.scReady = '1';
    var sel = widget.querySelector('[data-ship-calc-province]');
    provinces(widget).forEach(function (p) {
      var o = document.createElement('option');
      o.value = p[0];
      o.textContent = p[1];
      sel.appendChild(o);
    });
    var saved = load();
    if (saved) {
      sel.value = saved.province || '';
      widget.querySelector('[data-ship-calc-zip]').value = saved.zip || '';
      if (saved.ran && sel.value) { widget.open = true; run(widget); }
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ship-calc-submit]') : null;
    if (!btn) return;
    e.preventDefault();
    run(btn.closest('[data-ship-calc]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.closest ? e.target.closest('[data-ship-calc-zip]') : null;
    if (!input) return;
    e.preventDefault();
    run(input.closest('[data-ship-calc]'));
  });
  var pending = false;
  function scan() {
    pending = false;
    document.querySelectorAll('[data-ship-calc]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      (window.requestAnimationFrame || setTimeout)(scan);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
